import { render, staticRenderFns } from "./priceAirService.vue?vue&type=template&id=f8fced02&"
import script from "./priceAirService.vue?vue&type=script&lang=js&"
export * from "./priceAirService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8fced02')) {
      api.createRecord('f8fced02', component.options)
    } else {
      api.reload('f8fced02', component.options)
    }
    module.hot.accept("./priceAirService.vue?vue&type=template&id=f8fced02&", function () {
      api.rerender('f8fced02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/priceAirService.vue"
export default component.exports